export default "__VITE_ASSET__CGPhzhec__"